// import React, { useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import { useDispatch, useSelector } from 'react-redux'
// import { format, parseISO } from 'date-fns';

// import Spinner from '../Layout/Spinner';

// import { determineAuthorizationV2, toProperCase } from "../../utils/Helper"
// import { getAllSubs } from '../../features/contractSlice'

// const ManageSubscriptions = () => {
//     const dispatch = useDispatch()

//     const { role, email, idToken } = useSelector((state) => state.auth);
//     const { stripeSubs, agentInfo, loading } = useSelector((state) => state.contracts)
//     console.log("stripeSubs", stripeSubs)

//     useEffect(() => {
//         dispatch(getAllSubs({ email, idToken }))
//     }, [])

//     let { active } = determineAuthorizationV2(role, stripeSubs, agentInfo)

//     if (loading) {
//         return <Spinner />
//     }

//     return (
//         <div className='min-h-64 px-4 py-6'>
//             {stripeSubs.length > 0 && active ? (
//                 <div>
//                     <table className="w-full table-auto">
//                         <thead>
//                             <tr className="bg-gray-200">
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Subscription Duration
//                                 </th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Amount
//                                 </th>
//                                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                                     Status
//                                 </th>
//                             </tr>
//                         </thead>
//                         <tbody className="bg-white divide-y divide-gray-200">
//                             {stripeSubs.map((sub, index) => {
//                                 return <tr key={index} className={`${sub.status === "active" ? "bg-green-200" : " "} hover:bg-gray-100`}>
//                                     <td className="px-6 py-4 text-sm font-medium text-gray-900 text-blue-500 font-bold">
//                                         {format(parseISO(new Date(sub.current_period_start * 1000).toISOString().split("T")[0]), "MM/dd/yyyy")}- {format(parseISO(new Date(sub.current_period_end * 1000).toISOString().split("T")[0]), "MM/dd/yyyy")}
//                                     </td>
//                                     {/* <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                                         $ {sub.items.data[0].price.unit_amount / 100}
//                                     </td> */}
//                                     <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                                         {sub.discount ? (
//                                             <div>
//                                                 <div className="line-through text-gray-500">
//                                                     ${sub.items.data[0].price.unit_amount / 100}
//                                                 </div>
//                                                 <div>
//                                                     ${(sub.items.data[0].price.unit_amount * (1 - sub.discount.coupon.percent_off / 100) / 100).toFixed(2)}
//                                                     <span className="ml-1 text-green-600 text-xs">
//                                                         ({sub.discount.coupon.percent_off}% off)
//                                                     </span>
//                                                 </div>
//                                             </div>
//                                         ) : (
//                                             <div>
//                                                 ${sub.items.data[0].price.unit_amount / 100}
//                                             </div>
//                                         )}
//                                     </td>
//                                     <td className="px-6 py-4 text-sm font-medium text-gray-900 text-blue-500 font-bold">
//                                         {toProperCase(sub.status)}
//                                         <p>
//                                             {sub.status === "active" && (
//                                                 <Link className="text-sm text-red-600" to={`/sub/cancel/${sub.id}`}>Cancel</Link>
//                                             )}
//                                         </p>

//                                     </td>
//                                 </tr>
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             ) : (
//                 <div>
//                     <div className='mt-5 text-xl font-bold text-center'>Subscription Options</div>
//                     <div className='text-center grid grid-cols-1 gap-4 md:grid-cols-2'>
//                         <div className="relative flex flex-col mt-6 text-gray-700 bg-gray-100 shadow-md bg-clip-border rounded-xl w-100">
//                             <div className="p-6">
//                                 <h5 className="block mb-2 font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
//                                     Yearly Subscription
//                                 </h5>
//                                 <div className='italic font-semibold'>Best value for money</div>
//                                 <div className="block font-sans text-base antialiased font-light leading-relaxed text-inherit">
//                                     <p>
//                                         <span className="font-bold">$99.99/year</span>
//                                     </p>
//                                 </div>
//                             </div>
//                             <div className="p-6 pt-0">
//                                 <button
//                                     className="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
//                                     type="submit">
//                                     <Link to={`/sub/payment/annual`}>Subscribe</Link>

//                                 </button>

//                             </div>
//                         </div>
//                         <div className="relative flex flex-col mt-6  bg-gray-500 text-white shadow-md bg-clip-border rounded-xl w-100">
//                             <div className="p-6">
//                                 <h5 className="block mb-2 font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
//                                     Monthly Subscription
//                                 </h5>
//                                 <div className="block font-sans text-base antialiased font-light leading-relaxed text-inherit">
//                                     <p>
//                                         <span className="font-bold">$9.99/month</span>
//                                     </p>
//                                 </div>
//                             </div>
//                             <div className="p-6 pt-0">
//                                 <button
//                                     className="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
//                                     type="submit">
//                                     <Link to={`/sub/payment/monthly`}>Subscribe</Link>

//                                 </button>

//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}


//         </div>
//     )
// }

// export default ManageSubscriptions

import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { format, parseISO } from 'date-fns';

import Spinner from '../Layout/Spinner';

import { determineAuthorizationV2, toProperCase } from "../../utils/Helper"
import { getAllSubs } from '../../features/contractSlice'

const ManageSubscriptions = () => {
    const dispatch = useDispatch()

    const { role, email, idToken } = useSelector((state) => state.auth);
    const { stripeSubs, agentInfo, loading } = useSelector((state) => state.contracts)
    // console.log("stripeSubs", stripeSubs)

    useEffect(() => {
        dispatch(getAllSubs({ email, idToken }))
    }, [])

    let { active } = determineAuthorizationV2(role, stripeSubs, agentInfo)

    if (loading) {
        return <Spinner />
    }

    return (
        <div className='min-h-64 px-4 py-6 max-w-4xl mx-auto'>
            <h1 className="text-2xl font-bold text-center mb-6">Subscription Management</h1>

            {stripeSubs.length > 0 && active ? (
                <div className="bg-white rounded-lg shadow-md overflow-hidden">
                    <div className="p-4 bg-blue-50 border-b border-blue-100">
                        <h2 className="text-lg font-semibold text-blue-800">Your Active Subscriptions</h2>
                    </div>
                    <div className="overflow-x-auto">
                        <table className="w-full table-auto">
                            <thead>
                                <tr className="bg-gray-50 text-left border-b">
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Subscription Period
                                    </th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Amount
                                    </th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {stripeSubs.map((sub, index) => {
                                    return (
                                        <tr key={index} className={`${sub.status === "active" ? "bg-green-50" : ""} hover:bg-gray-50 transition-colors`}>
                                            <td className="px-6 py-4">
                                                <div className="text-sm font-medium text-gray-900">
                                                    {format(parseISO(new Date(sub.current_period_start * 1000).toISOString().split("T")[0]), "MMM dd, yyyy")} -
                                                    {format(parseISO(new Date(sub.current_period_end * 1000).toISOString().split("T")[0]), "MMM dd, yyyy")}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4">
                                                {sub.discount ? (
                                                    <div>
                                                        <div className="text-xs text-gray-500 line-through">
                                                            ${sub.items.data[0].price.unit_amount / 100}
                                                        </div>
                                                        <div className="text-sm font-medium text-gray-900 flex items-center">
                                                            <span className="font-bold">
                                                                ${(sub.items.data[0].price.unit_amount * (1 - sub.discount.coupon.percent_off / 100) / 100).toFixed(2)}
                                                            </span>
                                                            <span className="ml-2 px-2 py-0.5 bg-green-100 text-green-800 text-xs rounded-full">
                                                                {sub.discount.coupon.percent_off}% off
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="text-sm font-medium text-gray-900">
                                                        ${sub.items.data[0].price.unit_amount / 100}
                                                    </div>
                                                )}
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="flex flex-col">
                                                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${sub.status === "active" ? "bg-green-100 text-green-800" :
                                                        "bg-gray-100 text-gray-800"
                                                        }`}>
                                                        {toProperCase(sub.status)}
                                                    </span>

                                                    {sub.status === "active" && (
                                                        <Link
                                                            className="mt-2 text-sm text-red-600 hover:text-red-800"
                                                            to={`/sub/cancel/${sub.id}`}
                                                        >
                                                            Cancel
                                                        </Link>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : (
                <div>
                    <div className='text-xl font-bold text-center mb-6'>Subscription Options</div>
                    <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
                        <div className="relative flex flex-col bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
                            <div className="absolute top-0 right-0 bg-blue-500 text-white text-xs px-3 py-1 rounded-bl-lg font-semibold">
                                Best Value
                            </div>
                            <div className="p-6">
                                <h3 className="text-xl font-bold text-gray-800 mb-2">
                                    Yearly Subscription
                                </h3>
                                <div className="flex items-baseline mb-4">
                                    <span className="text-3xl font-bold text-blue-600">$99.99</span>
                                    <span className="text-gray-500 ml-1">/year</span>
                                </div>
                                <div className="italic text-sm text-gray-600 mb-6">Best value for money</div>
                            </div>
                            <div className="p-4 bg-gray-50 border-t border-gray-100 mt-auto">
                                <Link
                                    to={`/sub/payment/annual`}
                                    className="w-full block text-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
                                >
                                    Subscribe
                                </Link>
                            </div>
                        </div>

                        <div className="relative flex flex-col bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
                            <div className="p-6">
                                <h3 className="text-xl font-bold text-gray-800 mb-2">
                                    Monthly Subscription
                                </h3>
                                <div className="flex items-baseline mb-4">
                                    <span className="text-3xl font-bold text-gray-600">$9.99</span>
                                    <span className="text-gray-500 ml-1">/month</span>
                                </div>
                                <div className="italic text-sm text-gray-600 mb-6">Flexible option</div>
                            </div>
                            <div className="p-4 bg-gray-50 border-t border-gray-100 mt-auto">
                                <Link
                                    to={`/sub/payment/monthly`}
                                    className="w-full block text-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-600 hover:bg-gray-700"
                                >
                                    Subscribe
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ManageSubscriptions
